import axios from 'axios'
import Cookies from 'js-cookie'

let redirectingToLogin = false
let csrfRequest = null
let readAuthVersion = () => 0
let isLoggingOut = () => false
let expireAuth = () => {}
let canReadBusiness = () => true
let expiredVersion = null
let removePendingNavigation = () => {}
export function bindAuthVersion(reader, leaving = () => false, expired = () => {}, allowed = () => true) {
  removePendingNavigation()
  redirectingToLogin = false
  expiredVersion = null
  readAuthVersion = reader; isLoggingOut = leaving; expireAuth = expired; canReadBusiness = allowed
}
const service = axios.create({
  baseURL: '/api',
  withCredentials: true,
  xsrfCookieName: 'microquake_csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  timeout: 30000
})

service.interceptors.request.use(async config => {
  if (expiredVersion !== null && expiredVersion !== readAuthVersion()) {
    removePendingNavigation(); expiredVersion = null; redirectingToLogin = false
  }
  if ((expiredVersion !== null || !canReadBusiness()) && !config.skipAuthRedirect) throw new axios.CanceledError('登录状态不可用，等待恢复页面后重新核验。')
  config.authVersion = readAuthVersion()
  const method = (config.method || 'get').toLowerCase()
  if (!['get', 'head', 'options'].includes(method) && !Cookies.get('microquake_csrftoken')) {
    if (!csrfRequest) {
      csrfRequest = axios.get('/api/auth/csrf/', { withCredentials: true, timeout: 15000 })
        .finally(() => { csrfRequest = null })
    }
    await csrfRequest
  }
  return config
})

service.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && !error.config?.skipAuthRedirect && !redirectingToLogin && !isLoggingOut() &&
      error.config?.authVersion === readAuthVersion()) {
    redirectingToLogin = true
    expireAuth()
    expiredVersion = readAuthVersion()
    const nextPath = window.location.pathname + window.location.search + window.location.hash
    const doc = typeof document === 'undefined' ? null : document
    const navigate = () => {
      if (doc?.hidden) return
      removePendingNavigation()
      if (expiredVersion !== readAuthVersion() || isLoggingOut()) { expiredVersion = null; redirectingToLogin = false; return }
      window.location.replace('/login?next=' + encodeURIComponent(nextPath))
    }
    removePendingNavigation = () => doc?.removeEventListener('visibilitychange', navigate)
    if (doc?.hidden) doc.addEventListener('visibilitychange', navigate)
    else navigate()
  }
  return Promise.reject(error)
})

export default service
